import { render } from "./MisCotizaciones.vue?vue&type=template&id=52a81611&scoped=true"
import script from "./MisCotizaciones.vue?vue&type=script&lang=js"
export * from "./MisCotizaciones.vue?vue&type=script&lang=js"

import "./MisCotizaciones.vue?vue&type=style&index=0&id=52a81611&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a81611"]])

export default __exports__